import React from 'react';

class Privacy extends React.Component {
    render(){
        return (
            <div className="mainContent">
                <div className="textContent leftAlign">
                    <h2>Privacy Policy</h2>
                    <h3>Who we are</h3>
                    <p>Our website address is: https://www.friarscliffbeachcare.org.uk.</p>

                    <h3>What personal data we collect and why we collect it</h3>
                    <h4>Website</h4>
                    <p>We do not collect personal data on the website or store it anywhere on the web platform.</p>

                    <p>If you submit a contact form, the information that you include on that form will be sent via email, including your name and email address. This is not saved to a database. The information will be retained only for as long as required to:</p>
                    <ul>
                        <li>respond to your message</li>
                        <li>If you requested to join the mailing list, until such time as you request to be removed from that list</li>
                    </ul>
                    <br/>
                    <h4>Media</h4>
                    <p>If you upload images to the website or to our social media streams, you should avoid uploading images with embedded location data (EXIF GPS) included. Visitors to the website can download and extract any location data from images on the website.</p>
                    <br/>
                    <h3>Embedded content from other websites</h3>
                    <p>Articles on this site may include embedded content (e.g. videos, images, articles, etc.). Embedded content from other websites behaves in the exact same way as if the visitor has visited the other website.</p>
                    <br/>
                    <p>These websites may collect data about you, use cookies, embed additional third-party tracking, and monitor your interaction with that embedded content, including tracking your interaction with the embedded content if you have an account and are logged in to that website.</p>
                    <br/>
                    <h3>Who we share your data with</h3>
                    <p>We do not share your data with any other person or organisation.</p>
                    <br/>
                    <h3>How long we retain your data</h3>
                    <p>When you contact us, either through the website, directly via email or through joining the mailing list, your data will only be retained for as long as is required, which may be:</p>
                    <ul>
                        <li>The time required to respond to your message</li>
                        <li>Until you request to be removed from the mailing list</li>
                    </ul>
                    <br/>
                    <h3>What rights you have over your data</h3>
                    <p>You can contact us at any time and request that we remove your data from the mailing list.</p>
                    <br/>
                    <p>You can contact us using the Contact Form on this website or by emailing friarscliff.beachcare@gmail.com</p>
                    <br/>
                    <h3>Where we send your data</h3>
                    <p>We do not send your data anywhere.</p>
                    <br/>
                    <h3>Additional Information</h3>
                    <p>We do not collect or store your personal information. If you email us we will keep your email address only for as long as is needed to respond to your message. Your email address is not stored and will not be kept in any list, used for any purpose other than to respond to your message or passed on to any third parties.</p>
                    <br/>
                    <h3>How we protect your data</h3>
                    <p>All contact that is made goes through to our gmail account.</p>
                    <p>This account is only accessible to one person and is secured with two-factor authentication.</p>
                    <p>The website is secured with an SSL certificate</p>
                    <p>When sending emails to the mailing list, all email addresses are protected through the use of blind copy.</p>
                    <br/>
                    <h3>What data breach procedures we have in place</h3>
                    <p>For all data protection requirements, we follow guidance from the Information Commissioner’s Office and in the event of any data breach will refer to their guidance and take all necessary steps.</p>
                    <br/>
                    <h3>What third parties we receive data from</h3>
                    <p>We do not receive data from third parties</p>
                    <br/>
                    <h3>What automated decision making and/or profiling we do with user data</h3>
                    <p>We do not undertake any decision making or profiling with user data.</p>
                </div>
            </div>
        )
    }
}

export default Privacy;